export const meta = {
  appAlias: 'appointment-booking',
  appName: 'Appointment Booking'
};
